module.exports = __webpack_public_path__ + "img/spain_flag.edb7b95e.png";